import { SubscriptionExportStatus } from "api/models";
import { EXPORT_POLLING_INTERVAL } from "config/constants";
import { getSubscriptionExport } from "../../api";
import { useSelectedShop, useQueryWrapper } from "shared/hooks";
import { useDateRangeContext } from "../useDateRangeContext";

export const useSubscriptionExportPolling = (exportId: string | undefined) => {
  const { selectedShopId } = useSelectedShop();

  const { startDate, endDate } = useDateRangeContext();

  const { data, fetchStatus, isError } = useQueryWrapper(
    ["subscriptionsExport", selectedShopId, startDate?.toString(), endDate?.toString(), exportId],
    async () =>
      await getSubscriptionExport({
        shopId: selectedShopId!,
        exportId: exportId!
      }),
    {
      enabled: !!selectedShopId && !!startDate && !!endDate && !!exportId,
      refetchOnWindowFocus: false,
      retry: false,
      keepPreviousData: false,
      refetchInterval: (data, query) => {
        if (data?.status === SubscriptionExportStatus.READY || query.state.status === "error") {
          return false;
        }
        return EXPORT_POLLING_INTERVAL;
      }
    }
  );

  return {
    data,
    isPollingInProgress: fetchStatus === "fetching",
    isError
  };
};
